import React, { useState, useEffect, useRef } from 'react';
import { Grid, Typography, makeStyles, Box } from "@material-ui/core";
import { Formik } from 'formik';
import DadosCadastroAmostra from './DadosCadastroAmostra';
import { useForm } from '../customHooks';
import { connect } from 'react-redux'
import CadastroAmostrasManager from "../CadastroAmostrasManager";
import ModalCadastroAmostrasSucesso from '../../../shared/components/ModalCadastroAmostrasSucesso'
import ModalCadastroAmostrasErro from '../../../shared/components/ModalCadastroAmostrasErro'
import ScrollBarGradiente from "../../../shared/components/ScrollBarGradiente";
import { codigoDGK, codigoDLE, codigoToxicologia, codigosErros, codigoDGKPSC } from "../../../shared/utils/Constantes";
import { useHistory } from 'react-router-dom';
import { substituirElementoArray } from '../../../shared/utils/ArrayUtil';
import store from '../../../store';
import { mensagemAlertaActions } from '../../mensagemAlerta/redux';
import BotoesCadastro from './BotoesCadastro';
import { ContainerPagina } from '../../../shared/components/ContainerPagina';
import { obterMensagemErroDropzone } from '../../../shared/utils/DropzoneUtil';
import { MARGIN_TOP_TOTAL_CONTEUDO_PAGINA } from '../../../theme';
import { dadosAcesso } from '../../login/LoginManager'
import { useDadosSolicitante } from '../customHooks/useDadosSolicitante'

let contadorArquivos = 0;

const CadastroAmostras = ({ tipoCliente }) => {
    const history = useHistory();

    const [empresas, setEmpresas] = useState([]);
    const [disableEmpresas, setDisableEmpresas] = useState(false);
    const [defaultEmpresa, setDefaultEmpresa] = useState("");
    const [tiposAmostra, setTiposAmostra] = useState([]);
    const [tiposConservacao, setTiposConservacao] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [dadosForm, setDadosForm] = useState({});
    const [modalCadastroAmostrasSucessoAberto, setModalCadastroAmostrasSucessoAberto] = useState(false);
    const [modalCadastroAmostrasErroAberto, setModalCadastroAmostrasErroAberto] = useState(false);
    const [arquivos, setArquivos] = useState([]);
    const [quantidadeArquivosSendoEnviados, setQuantidadeArquivosSendoEnviados] = useState(0);
    const [listaConvenio, setListaConvenio] = useState([]);
    const dadosSolicitante = useDadosSolicitante();
    const [clienteDGKPSC, setclienteDGKPSC] = useState(false);
    const [dadosSolicitanteValido, setDadosSolicitanteValido] = useState(true); 
    const [saveCount, setSaveCount] = useState(0);
    const [enviandoPedidoMedico, setEnviandoPedidoMedico] = useState(false);
    const [enviandoArquivoDiverso, setEnviandoArquivoDiverso] = useState(false);

    const numeroEtiquetaRef = useRef();
    const classes = useStyles();

    useEffect(() => {
        if(dadosAcesso &&
            dadosAcesso.laboratorio &&
            dadosAcesso.laboratorio.captacao &&
            dadosAcesso.laboratorio.captacao === codigoDGKPSC){
                setclienteDGKPSC(true)
                if( dadosSolicitante.value.length !== 1
                    || dadosSolicitante.value[0].nome === ""){
                        setDadosSolicitanteValido(false)
                    }
                else{
                    setDadosSolicitanteValido(true)                    
                }
            }
    },[dadosSolicitante]) 

    useEffect(() => {
        const listarEmpresas = async () => {
            const response = await CadastroAmostrasManager.listarEmpresas();
            if (response && response.length > 0) {
                setEmpresas(response);
            }
            else {
                history.goBack();
            }
        };
        const listarTiposAmostra = async () => {
            const response = await CadastroAmostrasManager.listarTiposAmostra();
            if (response && response.length > 0) {
                setTiposAmostra(response.sort((a, b) => a.descricao.localeCompare(b.descricao)));
            }
            else {
                history.goBack();
            }
        }
        const listarTiposConservacao = async () => {
            const response = await CadastroAmostrasManager.listarTiposConservacao();
            if (response && response.length > 0) {
                setTiposConservacao(response.sort((a, b) => a.descricao.localeCompare(b.descricao)));
            }
            else {
                history.goBack();
            }
        }

        const listarConvenioPorLaboratorio = async () => {           
            if(dadosAcesso?.laboratorio?.captacao === codigoDGKPSC){
                const listConvenio = await CadastroAmostrasManager.listarConvenioPorLaboratorio(dadosAcesso.laboratorio.codigo);                                    
                
                if(listConvenio && listConvenio.length > 0) {
                setListaConvenio(listConvenio);               
                }        
            }                                     
        }       

        listarEmpresas();
        if (tipoCliente === codigoDGK ||
            tipoCliente === codigoDLE ||
            tipoCliente === codigoToxicologia) {

            setDefaultEmpresa(tipoCliente);
            setDisableEmpresas(true);
        }

        if (clienteDGKPSC) {
            setDefaultEmpresa(codigoDGK);
            setDisableEmpresas(true);
        }

        listarTiposAmostra();
        listarTiposConservacao();
        listarConvenioPorLaboratorio();
    }, [dadosAcesso, tipoCliente, clienteDGKPSC, history]);

    const resetForm = (formikResetFunc, setFieldValue) => {
        formikResetFunc();
        setFieldValue("empresa", defaultEmpresa ? defaultEmpresa : "");

        dadosSolicitante.resetSolicitante();
        setArquivos([]);

        setFieldValue('exames', []);    
        setFieldValue('material', null);       
        setFieldValue('especificacao', null);

        setSaveCount(saveCount + 1);

        setCamposTiveramFoco(initialFocus);
    }

    const handleGoBack = async () => {
        history.replace({
            pathname: "/amostras",
        });
    }

    const handleSubmit = async (dados, formikResetFunc, setFieldValue) => {
        setDadosForm(dados);

        dados = {
            ...dados,
            tipoAmostra: tiposAmostra.find((tipo) => tipo.codigo === dados.tipoAmostra)?.id,
            empresa: empresas.find((empresa) => empresa.codigo === dados.empresa),
            guidsArquivos: arquivos.map(arquivo => arquivo.guid),
        }

        setCarregando(true);

        const response = await CadastroAmostrasManager.cadastrarAmostra(dados);

        if (!response.error) {
            setModalCadastroAmostrasSucessoAberto(true);
            resetForm(formikResetFunc, setFieldValue);
        }
        else if (response.codigoErro !== codigosErros.AmostraJaCadastrada) {
            setModalCadastroAmostrasErroAberto(true);
        }

        setCarregando(false);
    }

    const handleFecharModal = () => {
        if (modalCadastroAmostrasSucessoAberto) {
            setModalCadastroAmostrasSucessoAberto(false);
            if (numeroEtiquetaRef?.current) {
                setTimeout(() => {
                    numeroEtiquetaRef.current.focus();

                    setCamposTiveramFoco(initialFocus);
                }, 1);
            }
        }
        if (modalCadastroAmostrasErroAberto) {
            setModalCadastroAmostrasErroAberto(false);
        }
    };

    const handleListagemAmostras = async () => {
        history.push({
            pathname: "/amostras",
        })
    };

    const handleErroArquivo = (arquivosComErro) => {
        const mensagemErro = obterMensagemErroDropzone(arquivosComErro);

        store.dispatch(mensagemAlertaActions.exibirNotificacao(mensagemErro));
    }

    const atualizarArquivoNaLista = (arquivoAtualizado) => {
        setArquivos((prev) => {
            const arquivos = [...prev];
            return substituirElementoArray(
                arquivos,
                arquivoAtualizado,
                (arq) => arq.idTemp === arquivoAtualizado.idTemp
            );
        });
    }

    const handleSucessoArquivos = (arquivosEnviados, pedidoMedico) => {
        const novosArquivos = arquivosEnviados.map(arq => {
            return {
                idTemp: ++contadorArquivos,
                nome: arq.name,
                dados: arq,
                guid: null,
                baixando: false,
                pedidoMedico: pedidoMedico !== undefined ? pedidoMedico: false,
                enviando: true
            }
        });

        if (pedidoMedico !== undefined) {
            if (pedidoMedico)
                setEnviandoPedidoMedico(true);
            else
                setEnviandoArquivoDiverso(true);
        }

        setArquivos(arquivos.concat(novosArquivos));

        novosArquivos.forEach(async (novoArquivo) => {
            const guid = await CadastroAmostrasManager.enviarArquivoTemporario(novoArquivo.dados);
            novoArquivo.enviando = false;

            if (guid) {
                atualizarArquivoNaLista({ ...novoArquivo, guid: guid });
            } else {
                setArquivos((prev) => prev.filter(arquivo => arquivo.idTemp !== novoArquivo.idTemp));
            }

            if (pedidoMedico !== undefined) {
                if (pedidoMedico)
                    setEnviandoPedidoMedico(false);
                else
                    setEnviandoArquivoDiverso(false);
            }
        });
    }


    useEffect(() => {
        const qtdEnviados = arquivos.reduce((a, v) => {
            if (v.enviando) {
                return a + 1
            }

            return a;
        }, 0);

        setQuantidadeArquivosSendoEnviados(qtdEnviados);
    }, [arquivos]);

    const handleBaixarArquivo = async (arquivo) => {
        atualizarArquivoNaLista({ ...arquivo, baixando: true });
        await CadastroAmostrasManager.baixarArquivoTemporario(arquivo.guid, arquivo.nome);
        atualizarArquivoNaLista({ ...arquivo, baixando: false });
    }

    const handleExcluirArquivo = (arquivo) => {
        const guid = arquivo.guid;
        CadastroAmostrasManager.excluirArquivoTemporario(guid);

        setArquivos((prev) => prev.filter(arq => arq.guid !== guid));
    }

    const {
        validationSchema,
        initialValues,
        initialErrors,
        camposTiveramFoco,
        setCamposTiveramFoco,
        initialFocus
    } = useForm(clienteDGKPSC);

    return (
        <Formik
            validationSchema={validationSchema}
            onSubmit={(dados, { resetForm, setFieldValue }) => handleSubmit(dados, resetForm, setFieldValue)}
            initialValues={initialValues}
            initialErrors={initialErrors}
            enableReinitialize
        >
            {({ handleSubmit, isValid, dirty, errors }) => (
                <ContainerPagina>
                    <ModalCadastroAmostrasSucesso
                        paciente={dadosForm.nomePaciente}
                        etiqueta={dadosForm.numeroEtiqueta}
                        tipo={tiposAmostra.find((tipo) => tipo.codigo === dadosForm.tipoAmostra)?.descricao}
                        setModalAberto={setModalCadastroAmostrasSucessoAberto}
                        modalAberto={modalCadastroAmostrasSucessoAberto}
                        handleClickBotaoPrincipalModal={handleListagemAmostras}
                        handleClickBotaoSecundarioModal={handleFecharModal}
                    />
                    <ModalCadastroAmostrasErro
                        setModalAberto={setModalCadastroAmostrasErroAberto}
                        modalAberto={modalCadastroAmostrasErroAberto}
                        handleClickBotaoModal={handleFecharModal}
                    />
                    <Box className={"largura-maxima " + classes.formulario}>
                        <ScrollBarGradiente
                            estilo={{ height: "100%", width: "100%" }}
                            exibirGradiente={false}
                            habilitarScrollHorizontal={false}
                            autoRolagem={arquivos && arquivos.length > 0 ? { direcao: "baixo" } : null}
                        >
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="h2" className={"mt-4"}>
                                        Cadastro de amostra
                                    </Typography>
                                    <Typography variant="body2">
                                        Em casos de etiquetas <span className={classes.spanSubtitulo}> pré-impressas
                                        </span>.
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <DadosCadastroAmostra
                                        key={saveCount}
                                        empresas={empresas}
                                        disableEmpresas={disableEmpresas}
                                        defaultEmpresa={defaultEmpresa}
                                        tiposAmostra={tiposAmostra}
                                        tiposConservacao={tiposConservacao}
                                        camposTiveramFoco={camposTiveramFoco}
                                        setCamposTiveramFoco={setCamposTiveramFoco}
                                        numeroEtiquetaRef={numeroEtiquetaRef}
                                        handleErroArquivo={handleErroArquivo}
                                        handleSucessoArquivos={handleSucessoArquivos}
                                        arquivos={arquivos}
                                        handleBaixarArquivo={handleBaixarArquivo}
                                        handleExcluirArquivo={handleExcluirArquivo}
                                        listConvenio={listaConvenio}
                                        handleChangeSolicitante={dadosSolicitante.handleChangeSolicitante}
                                        dadosSolicitante={dadosSolicitante.value}
                                        atualizarListaSolicitantes={dadosSolicitante.atualizarListaSolicitantes}
                                        clienteDGKPSC={clienteDGKPSC}
                                        ufLaboratorio={dadosAcesso?.laboratorio?.uf}
                                        possuiArquivoPedidoMedico={arquivos?.find(v=>v.pedidoMedico===true)}
                                        possuiArquivoDiversos={arquivos?.find(v=>v.pedidoMedico===false)}
                                        enviandoPedidoMedico={enviandoPedidoMedico}
                                        enviandoArquivoDiverso={enviandoArquivoDiverso}
                                    />
                                </Grid>
                            </Grid>
                        </ScrollBarGradiente>
                    </Box>
                    <Box className="largura-maxima mt-2">
                        <BotoesCadastro
                            handleSubmit={handleSubmit}
                            handleGoBack={handleGoBack}
                            isValid={isValid && dirty && (clienteDGKPSC ? (!enviandoPedidoMedico && !enviandoArquivoDiverso) : (quantidadeArquivosSendoEnviados === 0)) && dadosSolicitanteValido }
                            carregando={carregando}
                        />
                    </Box>
                </ContainerPagina>
            )}
        </Formik>
    );
}

export const ALTURA_RODAPE = "85px";
const useStyles = makeStyles((theme) => ({
    formulario: {
        height: `calc(100vh - ${MARGIN_TOP_TOTAL_CONTEUDO_PAGINA} - ${ALTURA_RODAPE})`,
    },
    spanSubtitulo: {
        fontWeight: '700'
    },
}));

const mapStateToProps = (state) => {
    return {
        tipoCliente: state.login.laboratorio.tipoCliente.codigo,
    }
}

export default connect(
    mapStateToProps,
    null
)(CadastroAmostras);